import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconForthTriangle8(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="8"
            height="8"
            viewBox="0 0 8 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="forward triangle">
            <path
                d="M7 4L1 8L1 0L7 4Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
